import React, { useEffect, useState } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

const toast = (m, t = "success") => {
  toastr.options = {
    closeButton: true,
    progressBar: true,
    timeOut: 3000,
  };

  toastr[t](m);
};

export default function OnboardingSettlement() {
  const [merchantList, setMerchantList] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);

  const [walletBalance, setWalletBalance] = useState(0);

  const [settlementForm, setSettlementForm] = useState({
    amount: "",
  });

  const [balanceLoading, setBalanceLoading] = useState(false);
  const [settlementLoading, setSettlementLoading] = useState(false);

  const [userList, setUserList] = useState([]);
  const [showVpaModal, setShowVpaModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);

  // ==========================
  // COMMON POST API
  // ==========================

  const postApi = async (url, payload) => {
    const res = await authFetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Request Failed");
    }

    return data;
  };

  // ==========================
  // LOAD MERCHANTS
  // ==========================

  const loadUsers = async () => {
    try {
      const res = await authFetch(
        "/api/v1/member/userlistactive"
      );

      const data = await res.json();

      setUserList(Array.isArray(data) ? data : []);
    } catch (err) {
      console.log(err);
      toast("Unable to load users", "error");
    }
  };

  const loadMerchants = async () => {
    try {
      const res = await authFetch(
        "/api/v1/member/topay/userlist"
      );

      const data = await res.json();

      setMerchantList(Array.isArray(data) ? data : []);
    } catch (err) {
      console.log(err);
      toast("Unable to load merchants", "error");
    }
  };

  // ==========================
  // WALLET BALANCE
  // ==========================

//   const getWalletBalance = async (
//     merchantId = selectedMerchant?.merchantId
//   ) => {
//     try {
//       if (!merchantId) {
//         return toast("Select Merchant", "warning");
//       }

//       setBalanceLoading(true);

//       const data = await postApi(
//         "/api/v1/member/topay/wallet-balance",
//         {
//           merchantId,
//         }
//       );

//       const balance =
//         data?.data?.wallets?.[0]?.availableBalance ||
//         data?.data?.wallets?.[0]?.balance ||
//         0;

//       setWalletBalance(balance);
//     } catch (err) {
//       console.log(err);
//       toast(err.message, "error");
//     } finally {
//       setBalanceLoading(false);
//     }
//   };

const getWalletBalance = async (
  merchantId = selectedMerchant?.merchantId
) => {
  try {

    const data = await postApi(
      "/api/v1/member/topay/wallet-balance",
      {
        merchantId,
      }
    );

    const generalWallet =
      data?.data?.result?.find(
        (item) => item.productId === "GENERAL"
      );

    setWalletBalance(
      Number(generalWallet?.balance || 0)
    );

  } catch (err) {
    toast(err.message, "error");
  }
};

  // ==========================
  // SELECT MERCHANT
  // ==========================

  const handleSelectMerchant = async (merchant) => {
    setSelectedMerchant(merchant);

    await getWalletBalance(
      merchant.merchantId
    );
  };

  // const autosettlementStatus = async (merchant) => {
  //   try {

  //     console.log("CURRENT:", merchant.auto_settlement);

  //     const newStatus = !merchant.auto_settlement;

  //     console.log("NEW STATUS:", newStatus);

  //     const payload = {
  //       merchantId: merchant.merchantId,
  //       auto_settlement: newStatus,
  //       settlement_threshold:
  //         merchant.settlement_threshold || 150000
  //     };

  //     console.log("PAYLOAD:", payload);

  //     const data = await postApi(
  //       "/api/v1/member/topay/auto-settlement",
  //       payload
  //     );

  //     console.log("API RESPONSE:", data);

  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const autosettlementStatus = async (
    merchant
  ) => {
    try {
      console.log("CURRENT:", merchant.auto_settlement);
      const data = await postApi(
        "/api/v1/member/topay/auto-settlement",
        {
          merchantId: merchant.merchantId,
          auto_settlement:
            !merchant.auto_settlement,

          settlement_threshold:
            merchant.settlement_threshold || 150000
        }
      );

      console.log("API RESPONSE:", data);
      
      toast(data.message);

      setMerchantList((prev) =>
        prev.map((m) =>
          m.merchantId === merchant.merchantId
            ? { ...m, auto_settlement: !m.auto_settlement }
            : m
        )
      );

      
      loadMerchants();

    } catch (err) {
      toast(err.message, "error");
    }
  };

  // ==========================
  // SETTLEMENT
  // ==========================

  const handleSettlement = async () => {
    try {
      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!settlementForm.amount) {
        return toast(
          "Enter Settlement Amount",
          "warning"
        );
      }

      setSettlementLoading(true);

      const data = await postApi(
        "/api/v1/member/topay/wallet-debit",
        {
          merchantId:selectedMerchant.merchantId,
          amount: settlementForm.amount,
          description: `Wallet Debit for UPI Merchant`,
          deviceInfo: selectedMerchant.deviceInfo,
        }
      );

      toast(
        data.message ||
          "Settlement Success"
      );

      setSettlementForm({
        amount: "",
      });

      getWalletBalance();
    } catch (err) {
      console.log(err);
      toast(err.message, "error");
    } finally {
      setSettlementLoading(false);
    }
  };

  const assignedUsers = merchantList
    .filter(
      (m) =>
        m.merchantId !==
        selectedMerchant?.merchantId
    )
    .flatMap((m) =>
      m.user_id
        ? m.user_id.split(",")
        : []
    );

  const saveVpaUsers = async () => {
    try {

      if (!selectedMerchant?.merchantId) {
        return toast("Select Merchant", "warning");
      }

      if (!selectedUsers.length) {
        return toast("Please select user", "warning");
      }

      const data = await postApi(
        "/api/v1/member/topay/assign-users",
        {
          merchantId: selectedMerchant.merchantId,
          user_id: selectedUsers,
        }
      );

      toast(data.message);

      setShowVpaModal(false);

      loadMerchants();

    } catch (err) {
      toast(err.message, "error");
    }
  };
  // ==========================
  // INIT
  // ==========================

  useEffect(() => {
    loadMerchants();
    loadUsers();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">

          <div className="card">
            <div className="card-body">

              <h5>Topay Merchant List</h5>

              <hr />

              <div className="table-responsive">

                <table className="table table-bordered table-striped">

                  <thead>
                    <tr>
                        <th>#</th>
                        <th>Merchant ID</th>
                        <th>Name</th>
                        <th>Amt Check</th>
                        <th>Auto Settlement</th>
                        <th>Switch VPA</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Bank</th>
                        <th>Account No</th>
                        <th>IFSC</th>
                        <th>Branch</th>
                        
                    </tr>
                  </thead>

                  <tbody>

                    {merchantList.map(
                      (merchant, index) => (
                        <tr key={index}>
                          <td>
                            {index + 1}
                          </td>
                          <td>
                            <span className="badge bg-dark">
                              {
                                merchant.merchantId
                              }
                            </span>
                          </td>
                          <td>{merchant.name}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() =>
                                handleSelectMerchant(
                                  merchant
                                )
                              }
                            >
                              Select
                            </button>

                            
                          </td>
                          <td>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={merchant.auto_settlement === true}
                                onChange={() =>
                                  autosettlementStatus(merchant)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => {
                                  setSelectedMerchant(merchant);

                                  setSelectedUsers(
                                    merchant.user_id
                                      ? merchant.user_id.split(",")
                                      : []
                                  );

                                  setShowVpaModal(true);
                                }}
                              >
                                VPA Switch
                              </button>
                          </td>
                          <td>{merchant.email}</td>        
                          <td>{merchant.mobile}</td>
                          <td>{merchant.bankName}</td>
                          <td>{merchant.accountno}</td>
                          <td>{merchant.ifscCode}</td>
                          <td>{merchant.branchName}</td>
                          
                        </tr>
                      )
                    )}

                  </tbody>

                </table>

              </div>
            </div>
          </div>

          {selectedMerchant && (
            <div className="card mt-4">
              <div className="card-body">

                <h5>
                  Settlement -
                  {" "}
                  {selectedMerchant.name}
                </h5>

                <hr />

                {/* <div className="row mb-3">

                  <div className="col-md-3">

                    <button
                      className="btn btn-primary w-100"
                      onClick={
                        getWalletBalance
                      }
                      disabled={
                        balanceLoading
                      }
                    >
                      {balanceLoading
                        ? "Loading..."
                        : "Refresh Balance"}
                    </button>

                  </div>

                </div> */}

                <div className="alert alert-success">

                  <h5 className="mb-0">
                    Wallet Balance : ₹
                    {" "}
                    {walletBalance}
                  </h5>

                </div>

                <div className="row">

                  <div className="col-md-4">

                    <input
                      type="number"
                      className="form-control"
                      placeholder="Settlement Amount"
                      value={
                        settlementForm.amount
                      }
                      onChange={(e) =>
                        setSettlementForm({
                          amount:
                            e.target.value,
                        })
                      }
                    />

                  </div>

                  <div className="col-md-3">

                    <button
                      className="btn btn-success w-100"
                      onClick={
                        handleSettlement
                      }
                      disabled={
                        settlementLoading
                      }
                    >
                      {settlementLoading
                        ? "Processing..."
                        : "Settlement Request"}
                    </button>

                  </div>

                </div>

              </div>
            </div>
          )}

          {
  showVpaModal && (
    <div className="modal d-block">
      <div className="modal-dialog">
        <div className="modal-content">

          <div className="modal-header">
            <h5>Assign Users</h5>

            <button
              className="btn-close"
              onClick={() =>
                setShowVpaModal(false)
              }
            />
          </div>

          <div className="modal-body">

            {userList.map((user) => {
              const disabled =
                assignedUsers.includes(
                  user.id
                );

              return (
                <div
                  key={user.id}
                  className="form-check mb-2"
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    disabled={disabled}
                    checked={selectedUsers.includes(
                      user.id
                    )}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedUsers(
                          [
                            ...selectedUsers,
                            user.id,
                          ]
                        );
                      } else {
                        setSelectedUsers(
                          selectedUsers.filter(
                            (id) =>
                              id !== user.id
                          )
                        );
                      }
                    }}
                  />

                  <label
                    className="form-check-label"
                  >
                    {user.name}
                    {" - "}
                    {user.merchantcode}

                    {disabled && (
                      <span className="text-danger ms-2">
                        Assigned
                      </span>
                    )}
                  </label>
                </div>
              );
            })}
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={() =>
                setShowVpaModal(false)
              }
            >
              Close
            </button>

            <button
              className="btn btn-success"
              onClick={saveVpaUsers}
            >
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  )
}

        </div>
      </div>
    </div>
  );
}